import config from "../../config";
import FloatingLabelInput from "../common/inputs/FloatingLabelInput";
import Modal from "../common/modals/Modal";

const ContactModal = ({ t, contact, onClose }) => {
  const isSent = contact.isSent;
  const logo = <div className="big-modal-main"><img src={config.globalLogo} alt="Logo"></img></div>

  const handleClose = () => {
    onClose(isSent);
  }

  // Convertimos la fecha a un formato legible antes de mostrarla en el input
  const startDate = contact.startDate ? new Date(contact.startDate).toLocaleDateString('es-ES') : '';
  const endDate = contact.endDate ? new Date(contact.endDate).toLocaleDateString('es-ES') : '';

  const sentBody = (isSent &&
    <div className="big-modal-main">
      <h2>{t("pages.contact.modal.title_sent", { returnObjects: true })}</h2>
      <div className="input-container">
        <FloatingLabelInput label={t("pages.contact.modal.name")} value={contact.name} disabled />
        <FloatingLabelInput label={t("pages.contact.modal.subject")} value={contact.subject} disabled />
        
        {/* NUEVO CAMPO: Muestra la fecha seleccionada en el resumen de éxito */}
        {contact.subjectId !== '2' && (
          <>
            <FloatingLabelInput 
            label={t("pages.contact.modal.startDate")} 
            value={startDate} 
            disabled 
          />
          </>
        )}
        {contact.subjectId === '1' && (
          <>
          <FloatingLabelInput 
            label={t("pages.contact.modal.endDate")} 
            value={endDate} 
            disabled 
          />
          </>
        )}
        
        {contact.subjectId === '0' && (
          <>
            <FloatingLabelInput 
              label={t("pages.contact.modal.startTime")} 
              value={contact.startTime} 
              disabled 
            />
            <FloatingLabelInput 
              label={t("pages.contact.modal.endTime")} 
              value={contact.endTime} 
              disabled 
            />
          </>
        )}
        {contact.subjectId === '2'? (
        <FloatingLabelInput 
          label={t("pages.contact.modal.body")} 
          value={contact.body} 
          disabled 
        />
        ): (<FloatingLabelInput 
          label={t("pages.contact.modal.information_price")} 
          value={contact.price} 
          disabled 
        />)}

        
      </div>
    </div>
  );

  const sentButton = (
    <button onClick={handleClose} className="modal-button close-modal-button">{t("pages.contact.modal.close", { returnObjects: true })}</button>
  );

  const notSentBody = (!isSent &&
    <div className="big-modal-main">
      <h2>{t("pages.contact.modal.title_not_sent", { returnObjects: true })}</h2>
      <div className="input-container">
        {t("pages.contact.modal.text_not_sent")}
      </div>
      <img src="/images/result/vote-no_12503624.png" alt="Error" width="50px" height="50px" style={{ marginBottom: "10px"}}/>
    </div>
  );

  const notSentButton = (
    <button onClick={handleClose} className="modal-button continue-modal-button">{t("pages.contact.modal.try_again", { returnObjects: true })}</button>
  );

  return (
    <Modal
      body={isSent ? sentBody : notSentBody}
      footerButton={isSent ? sentButton : notSentButton}
      onBack={handleClose}
      onClose={handleClose}
    />
  );
};

export default ContactModal;